import styled from 'styled-components/macro';

export const IncrementDecrement = styled.div`
  z-index: 201;
  width: 6rem;
  text-align: center;
  height: 2.6rem;
  background-color: #ffffff;
  border-radius: 5px;
  border-style: solid;
  border-width: 2px;
  border-color: #ffffff;
  user-select: none;

  &:hover {
    border-style: solid;
    border-width: 2px;
    border-color: #6ca8ff;
  }
`;

export const IncrementDecrementInner = styled.div`
  position: relative;
  margin: 0.1rem 0.4rem;
`;
